import ImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/ImageWithTextSection';
import IImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/types';
import { Trans, useTranslation } from 'react-i18next';

function ImageSection() {
  const { t } = useTranslation();

  const imageSectionItems: IImageWithTextSection[] = [
    {
      title: t('landing.imageSection.0.title'),
      description: (
        <Trans i18nKey={'landing.imageSection.0.description'} components={{ a: <a /> }} />
      ),
      imageWidth: 253,
      imgSrc: 'https://cdn140.picsart.com/65285504359551658104.webp',
      imgAlt: 'what is a jpg file',
      imageRight: true,
    },
    {
      title: t('landing.imageSection.1.title'),
      description: (
        <Trans i18nKey={'landing.imageSection.1.description'} components={{ a: <a /> }} />
      ),
      imageWidth: 253,
      imgSrc: 'https://cdn140.picsart.com/50070808214615306722.webp',
      imgAlt: 'what is a png file',
    },
    {
      title: t('landing.imageSection.2.title'),
      description: t('landing.imageSection.2.description'),
      imageWidth: 277,
      imgSrc: 'https://cdn140.picsart.com/08169735223603608976.webp',
      imgAlt: 'jpg to png converter for free',
      imageRight: true,
    },
  ];

  return (
    <>
      {imageSectionItems.map((props, index) => (
        <ImageWithTextSection {...props} key={index} />
      ))}
    </>
  );
}

export default ImageSection;
